import { useNavigate } from 'react-router-dom';
import { Instagram, ArrowRight } from 'lucide-react';
import { C } from '../constants';

const FOOTER_LINKS = [
  {
    group: 'Platform',
    links: [
      { label: 'How It Works',      path: '/how-it-works' },
      { label: 'Election Calendar',  path: '/election-calendar' },
      { label: '7 States in 2027',   path: '/2027' },
    ],
  },
  {
    group: 'States',
    links: [
      { label: 'Tamil Nadu 2026',      path: '/tn' },
      { label: 'West Bengal 2026',     path: '/wb' },
      { label: 'Mock 2029 Lok Sabha',  path: '/cockroach-janata-party-elections' },
    ],
  },
  {
    group: 'Learn',
    links: [
      { label: 'Blog',  path: '/blog' },
      { label: 'FAQ',   path: '/faq' },
      { label: 'About',   path: '/about' },
      { label: 'Contact', path: '/contact' },
    ],
  },
  {
    group: 'Legal',
    links: [
      { label: 'Privacy Policy', path: '/privacy' },
    ],
  },
];

export default function SiteFooter() {
  const navigate = useNavigate();

  return (
    <>
      {/* Instagram CTA — above the footer */}
      <div className="flex justify-center py-8 relative z-10">
        <a
          href="https://instagram.com/unofficialelections"
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2"
          style={{
            fontWeight: 600, color: C.white, fontSize: '0.9rem',
            padding: '9px 18px', borderRadius: 999,
            background: 'rgba(255,255,255,0.05)', border: `1px solid ${C.border}`,
            backdropFilter: 'blur(12px)', textDecoration: 'none',
            transition: 'border-color 200ms ease, box-shadow 200ms ease',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = C.pink; e.currentTarget.style.boxShadow = '0 0 20px rgba(255,77,158,0.3)'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.boxShadow = 'none'; }}
        >
          <Instagram size={15} color={C.pink} />
          Follow @unofficialelections for results
          <ArrowRight size={13} />
        </a>
      </div>

      {/* Footer */}
      <footer
        className="relative z-10"
        style={{ borderTop: `1px solid ${C.border}`, background: 'rgba(255,255,255,0.02)' }}
      >
        <div className="px-5 md:px-10 py-8">

          {/*
            Mobile:  logo full-width (col-span-2), then 2×2 link grid
            Desktop: logo + 4 link columns side by side
          */}
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-6 items-start">

            {/* Logo — spans full width on mobile, one column on desktop */}
            <div className="col-span-2 md:col-span-1 mb-2 md:mb-0">
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={() => navigate('/')}
                style={{ marginBottom: '0.65rem' }}
              >
                <img
                  src="/ue-logo.jpg"
                  alt="UE Logo"
                  style={{ width: 32, height: 32, borderRadius: 7, flexShrink: 0, objectFit: 'cover' }}
                />
                <div>
                  <div style={{ fontWeight: 700, fontSize: '0.95rem', color: C.white, lineHeight: 1.2 }}>
                    Unofficial<span style={{ color: '#F97316' }}>Election</span>
                  </div>
                  <div style={{
                    fontSize: '0.62rem', fontWeight: 600,
                    background: `linear-gradient(90deg, ${C.cyan}, ${C.pink})`,
                    WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent',
                  }}>
                    unofficialelections.com
                  </div>
                </div>
              </div>
              <p style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.3)', lineHeight: 1.6, margin: 0 }}>
                India's free anonymous election polling platform.
              </p>
            </div>

            {/* Link columns — each occupies one cell in the 2-col mobile / 4-col desktop grid */}
            {FOOTER_LINKS.map(({ group, links }) => (
              <div key={group}>
                <div style={{
                  fontSize: '0.62rem', letterSpacing: '0.16em', textTransform: 'uppercase',
                  color: C.textDim, fontWeight: 700, marginBottom: '0.8rem',
                }}>
                  {group}
                </div>
                <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  {links.map(({ label, path }) => (
                    <li key={path}>
                      <button
                        onClick={() => navigate(path)}
                        style={{
                          background: 'none', border: 'none', padding: 0, cursor: 'pointer',
                          fontFamily: "'Poppins', sans-serif",
                          fontSize: '0.83rem', color: 'rgba(255,255,255,0.5)',
                          transition: 'color 150ms ease',
                          textAlign: 'left',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.color = C.white; }}
                        onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; }}
                      >
                        {label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Copyright */}
          <div style={{ marginTop: '2rem', paddingTop: '1.25rem', borderTop: `1px solid ${C.border}` }}>
            <span style={{ fontSize: '0.68rem', color: 'rgba(255,255,255,0.25)' }}>
              © unofficialelections.com · Unofficial · non-political · entertainment only.
            </span>
          </div>

        </div>
      </footer>
    </>
  );
}
